import { ApolloProvider, InMemoryCache } from '@apollo/client'
import { apiDomain, apiKey } from 'helpers/request'
import { createClient } from 'helpers/createClient'

export const client = createClient(
  `${apiDomain}/planner/graphql`,
  apiKey,
  new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          show: {
            keyArgs: ['event_id', 'show_id'],
          },
        },
      },
    },
  }),
)

export default function PlannerGraphQLProvider({ children }) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
